import store from '@/store'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    return store.state.invoice.provider.document !== value
  }
}
